import { useEffect, useState } from "react";
import { ShieldAlert } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Señal CONFIDENCIAL de coincidencia PUI/RENAPO en el expediente del cliente.
// Visible SOLO para Oficial de Cumplimiento. No bloquea ninguna operación.
export function PuiSenalBanner({ clienteId }) {
  const { user } = useAuth();
  const [senal, setSenal] = useState(null);
  const esOC = user?.role === "oficial_cumplimiento";

  useEffect(() => {
    if (!esOC || !clienteId) { setSenal(null); return; }
    api.get(`/pui/senal/${clienteId}`).then(({ data }) => setSenal(data)).catch(() => setSenal(null));
  }, [clienteId, esOC]);

  if (!esOC || !senal?.tiene_coincidencia) return null;

  return (
    <div data-testid="pui-senal-confidencial" className="mb-3 flex items-start gap-2 rounded-md border border-red-200 bg-red-50 px-3 py-2.5 text-xs text-red-800">
      <ShieldAlert className="mt-0.5 h-4 w-4 shrink-0" />
      <div>
        <p className="font-semibold">Coincidencia con reporte de búsqueda de persona (PUI/RENAPO) — CONFIDENCIAL</p>
        <p className="mt-0.5">
          La CURP de este cliente coincide con {senal.senales.length} reporte(s) activo(s) de la PUI
          (folio{senal.senales.length > 1 ? "s" : ""}: {senal.senales.map((s) => s.folio_pui).join(", ")}).
          Información reservada para el Oficial de Cumplimiento. No notifiques ni adviertas al cliente; no bloquea operaciones.
          Las coincidencias se reportan automáticamente a la PUI.
        </p>
      </div>
    </div>
  );
}
